const endpoints = {
	create: '/additionals/create',
	update: '/additionals/update',
	list: '/additionals/list',
	listPaymentStatus: '/additionals/listPaymentStatus',
	getAdditionalByID: '/additionals/getAdditionalByID',
	addRevision: '/additionals/addRevision',
	createAdditionalLikely: '/additionals/createAdditionalLikely',
	listAdditionalLikely: '/additionals/listAdditionalLikely',
	getAdditionalLikely: '/additionals/getAdditionalLikely',
	getLastAdditionalData: '/additionals/getLastAdditionalData',
	newPaymentStatus: '/additionals/newPaymentStatus',
	editPaymentStatus: '/additionals/editPaymentStatus',
	setStatusToAgps: '/additionals/setStatusToAgps',
	addGlobalPaymentStatusParticipant: '/additionals/addGlobalPaymentStatusParticipant',
	removeGlobalPaymentStatusParticipant: '/additionals/removeGlobalPaymentStatusParticipant',
	updatePaymentStatus: '/additionals/updatePaymentStatus',
	setStatusToPaymentStatus: '/additionals/setStatusToPaymentStatus',
	newPaymentStatusInteraction: '/additionals/newPaymentStatusInteraction',
	changeVisualizationStatus: '/additionals/changeVisualizationStatus',
	changeAdditionalStatus: '/additionals/changeAdditionalStatus',
	addAdditionalAssociations: '/additionals/addAdditionalAssociations',
	removeAdditionalAssociations: '/additionals/removeAdditionalAssociations',
	getAdditionalPDF: '/additionals/getAdditionalPDF',
	getAgpsPDF: '/additionals/getAgpsPDF',
	sendAdditionalMail: '/additionals/sendAdditionalMail',
	addObservation: '/additionals/addObservation',
	addInteraction: '/additionals/addInteraction',
	getZippedFiles: '/additionals/getZippedFiles',
	createAdditionalProgress: '/additionals/createAdditionalProgress',
	getTareaAgpAssociation: '/additionals/getTareaAgpAssociation',
	getAdditionalsSimpleSummary: '/additionals/getAdditionalsSimpleSummary',
	exportAdditionalStatusByProject: '/exports/exportAdditionalStatusByProject',
	exportAdditionalPaymentStatusByProject: '/exports/exportAdditionalPaymentStatusByProject',
	exportCombinedAdditionalData: '/exports/exportCombinedAdditionalData',
}
export {endpoints}